import { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';
import PageContainer from '@components/Layout/PageContainer';
import Listing from './Listing';
import EditModal from './EditModal';

const Container = styled(PageContainer)({
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 1024px)': {
        padding: '24px 16px',
        overflowX: 'hidden',
    },
});

const VIEW = {
    FORM: 0,
    CODE: 1,
};

const WidgetsPage = memo(() => {
    const { t } = useTranslation();
    const [modal, setModal] = useState({ open: false, type: null, view: VIEW.FORM });

    const account = useSelector(state => state.account?.account);
    const locations = useSelector(state => state.account?.account?.companies || []);
    const brands = useSelector(state => state.brands.data);

    const onClickCard = type => setModal({ open: true, type, view: VIEW.FORM });

    return (
        <Container>
            <Typography variant="h6" color="textPrimary">
                {t('ShowcaseWidgets.title')}
            </Typography>
            <Typography variant="body2" sx={{ margin: '4px 0 16px', color: 'var(--text-secondary)' }}>
                {t('ShowcaseWidgets.subtitle')}
            </Typography>
            <Listing onClickCard={onClickCard} />
            {modal.open && (
                <EditModal
                    modal={modal}
                    setModal={setModal}
                    account={account}
                    view={VIEW}
                    locations={locations}
                    brands={brands}
                />
            )}
        </Container>
    );
});

WidgetsPage.displayName = 'WidgetsPage';

export default WidgetsPage;
